import React, { useEffect, useState } from 'react';
import { Row, Col, Button } from 'react-bootstrap5';

import UserCard from 'components/new_ui/Cards/UserCard';
import { useContext as useUsersContext } from 'components/Users/Context';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import Modal from 'components/new_ui/Modal/Modal';
import ValueItem from 'components/Widgets/Profile/ValueItem';

import General from './Forms/General';
import Basic from './Forms/Basic';
import Password from './Forms/Password';

export default function Main() {
  const { dispatch: dispatchUsers, actions: actionsUsers, state: stateUsers } = useUsersContext();
  const [formType, setFormType] = useState(null);

  function dateFormat(value) {
    const date = new Date(value);
    const options = {
      year: 'numeric',
      month: 'long',
    };

    return date.toLocaleDateString('en-US', options);
  }

  useEffect(() => {
    actionsUsers.load(dispatchUsers);
  }, []);

  if (stateUsers.user === null) {
    return (
      <div className="content user-profile">
        <section>
          <h1>Profile</h1>
        </section>

        <section>
          <LoadingPlaceholder text="Loading..." />
        </section>
      </div>
    );
  }

  const openForm = (typeForm) => {
    setFormType(typeForm);
  };

  const affiliate = stateUsers.user.attributes.specific;

  return (
    <>
      <div className="content user-profile">
        <section>
          <h1>Profile</h1>
        </section>

        <section>
          <Row>
            <Col lg={6} className="mb-5 mb-lg-0">
              <div className="text-end">
                <Button onClick={() => openForm('general')} variant="link">Edit</Button>
              </div>

              <UserCard
                name={affiliate.full_name}
                position={affiliate.company_name}
                className="affiliate"
                startWorkDate={(
                  <div className="work-date">
                    since
                    <br />
                    {dateFormat(affiliate.created_at)}
                  </div>
                )}
              />
            </Col>

            <Col lg={6} className="mb-4 mb-lg-0">
              <div className="d-flex justify-content-between">
                <div className="block-title">Basic Info</div>
                <Button onClick={() => openForm('basic')} variant="link">Edit</Button>
              </div>

              <ValueItem
                key="time-zone"
                icon="time-zone-icon"
                label="Time Zone"
              >
                {affiliate.time_zone}
              </ValueItem>

              <ValueItem
                key="address"
                icon="address-icon"
                label="Address"
              >
                {affiliate.full_address}
              </ValueItem>

              <ValueItem
                key="phone"
                icon="phone-icon"
                label="Mobile Phone"
              >
                {affiliate.phone}
              </ValueItem>

              <ValueItem
                key="email"
                icon="email-icon"
                label="Email"
              >
                {affiliate.email}
              </ValueItem>

              <ValueItem
                key="password"
                icon="password-icon"
                label="Password"
              >
                <Button onClick={() => openForm('password')} variant="link">Change password</Button>
              </ValueItem>
            </Col>
          </Row>
        </section>
      </div>

      <Modal size="lg" show={formType !== null}>
        {formType === 'general' && <General onCloseClick={() => setFormType(null)} />}
        {formType === 'basic' && <Basic onCloseClick={() => setFormType(null)} />}
        {formType === 'password' && <Password onCloseClick={() => setFormType(null)} />}
      </Modal>
    </>
  );
}
